interface DataItem {
  id?: number;
  label?: string;
  value?: number;
  barColor?: string;
  svgColor?: string;
}

interface BarsProps {
  data: DataItem[];
  width?: string;
  spacing?: number;
  barLabels?: string[];
}
interface BarProps {
  item?: {
    id?: number;
    label?: string;
    value?: number;
    barColor?: string;
    svgColor?: string;
    height?: string;
    maxHeight?: number;
  };
  width?: string;
  maxHeight?: number;
  label?: string;
}

const Bar = ({ item, width, label }: BarProps) => {
  const { height, barColor, svgColor, value } = item || {};

  return (
    <div>
      <div
        className={`flex min-h-[70px] items-end justify-center rounded-t-xl`}
        style={{
          backgroundColor: barColor,
          height,
          width,
        }}
      >
        <svg
          width="75%"
          height="72"
          viewBox="0 0 57 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M55.0142 39.0602C49.4928 24.4873 29.8337 23.7015 34.5814 2.52071C34.9331 0.949125 33.2802 -0.265285 31.9438 0.556228C19.68 7.89917 15.6093 14.8229 15.308 30.567C15.2831 31.8716 15.8007 33.4312 14.8928 34.3684C14.3026 34.9776 13.3288 35.2106 12.6521 34.6536C11.47 33.6807 9.52359 31.4505 8.5921 28.7377C7.6606 26.0248 6.41166 25.9874 5.39178 27.5233C3.00034 31.238 0.57373 37.2386 0.57373 46.2752C1.91012 66.2773 18.5447 72.4208 24.5233 73.2066C33.0692 74.3138 42.3185 72.7065 48.9653 66.5273C56.2803 59.6337 58.953 48.6326 55.0142 39.0602Z"
            fill={svgColor}
          />
          <text
            x="50%"
            y="70%"
            textAnchor="middle"
            dominantBaseline="middle"
            fill={barColor}
            fontWeight="500"
            fontSize="25.47px"
            fontFamily="Neo Sans Arabic"
          >
            {value}
          </text>
        </svg>
      </div>
      <div className="text-center">{label}</div>
    </div>
  );
};

export const BasicBars = ({
  data = [],
  width = "115px",
  spacing = 2,
  barLabels = [],
}: BarsProps) => {
  const maxHeight = Math.max(...data.map((item) => item.value || 1));

  return (
    <div className="flex w-full items-end justify-center gap-x-4">
      {data?.length &&
        data?.map((item, index) => (
          <Bar
            key={item.id}
            item={{
              id: item?.id,
              label: item?.label,
              value: item?.value,
              barColor: item?.barColor,
              height: `${((item?.value || 0) / maxHeight) * 140 + 70}px`,
              svgColor: item?.svgColor,
            }}
            width={width}
            label={barLabels[index]}
          />
        ))}
    </div>
  );
};
